
Vivense.init['category'] = Vivense.init['category'] || [];
Vivense.init['search'] = Vivense.init['search'] || [];
Vivense.init['upholstery-fabric'] = Vivense.init['upholstery-fabric'] || [];

var categorySearchJS = function() {

    var blockUIOpts = {
        message: '<div class="vivense-loading-icon"><img src="/img/page-loading-vivense-logo.svg"></div>',
        fadeIn: 150,
        fadeOut: 50,
        centerY: false,
        centerX: false,
        css: {
            border: 'none',
            backgroundColor: 'none',
            position: 'fixed',
            margin: 'auto'
        },
        overlayCSS: {
            backgroundColor: '#fff',
            opacity: 0.6,
            cursor: null,
            color: '#fff'
        }
    };

    var searchBody = $('#search-body'),
        h1 = $("h1"),
        title = $("title");

    var clearInProgress  = false;

    function blockUI() {
        searchBody.block(blockUIOpts);
    }

    function unblockUI() {
        searchBody.unblock(blockUIOpts);
    }

    /**
     * Sometimes chrome does not repaint. This solution is from
     * http://stackoverflow.com/questions/3485365/how-can-i-force-webkit-to-redraw-repaint-to-propagate-style-changes
     */
    function forceRepaint(searchBody) {
        if ( ! searchBody || searchBody.length == 0) {
            return;
        }

        var domElement = searchBody.get(0);

        domElement.style.display = 'none';
        domElement.style.display = '';
    }

    // ********************** SEARCH LOGIC *************************************

    function gaEvent(category, action, label) {

        dataLayer.push({
            'Category' : category,
            'Action' : action,
            'Label': label,
            'event':'gaEvent'
        });

    }

    function trackPageView(data) {
        dataLayer.push({
            'event': 'VirtualPageview',
            'virtualPageURL': data.url,
            'virtualPageTitle' : data.title
        });
    }

    function partialSearchFailure(data, textStatus, jqXHR) {
        alert('Bir hata oluştu. Lütfen tekrar deneyin.');
        unblockUI();
    }

    /*
     * This is required to avoid memory leaks. Lazy load plugin & dataLayer causes memory leak.
     */
    function resetBeforeRepaint() {
        $(window).unbind('scroll');
        $(window).unbind('resize');
        searchBody.empty();

        if (window.google_tag_manager && window.google_tag_manager["GTM-WZ4DPK"]) {
            window.google_tag_manager["GTM-WZ4DPK"].dataLayer.reset();
        }

        window.dataLayer.length = 0;
        window.viveCategoryPage.dataLayerPushedProducts = [];
    }

    function displayPartialSearchResult(data) {
        resetBeforeRepaint();

        searchBody.html(data.html);
        h1.html(data.h1);
        title.text(data.title);

        if(Vivense.favoriteActions){
            Vivense.favoriteActions.init();
        }

        if(window.viveUpholeSteryPage){
            window.viveUpholeSteryPage.init();
        }

        window.viveCategoryPage.initDynamicElements();

        forceRepaint(searchBody);

        trackPageView(data);

    }

    function popstate(event) {
        var state = event.state;

        if ( ! state || (! state.ajaxData && ! state.initialState)) {
            return;
        }

        if(state.infiniteScroll){
            return;
        }

        blockUI();

        if (state.initialState) {
            window.location.reload();
            return;
        }

        $.ajax('/ajax/search/partial.php?currentPage='+window.currentPage, {
            method: 'GET',
            data: state.ajaxData
        })
        .done(function (data, textStatus, jqXHR) {
            if ( ! data.success) {
                return;
            }


            displayPartialSearchResult(data);

            unblockUI();
        })
        .fail(partialSearchFailure);
    }

    function executeSearch(isMobile) {

        blockUI();

        var requestData = [];

        if(!isMobile){
            requestData = $('#searchForm').serializeArray();
        }
        else{
            requestData = $('#mobileSearchForm').serializeArray();
        }

        requestData.push({
            name : 'originalPath',
            value: window.location.pathname
        });

        $.ajax('/ajax/search/partial.php?currentPage='+window.currentPage, {
            method: 'GET',
            data: requestData
        })
        .done(function (responseData, textStatus, jqXHR) {
            if ( ! responseData.success) {
                return;
            }
            

            displayPartialSearchResult(responseData);

            var historyData = {
                ajaxData : requestData,
                originalPath : window.location.pathname,
                newUrl : responseData.url
            };

            history.pushState(historyData, responseData.title, responseData.url);

            if(window.ProductPlpCampaigns && typeof window.ProductPlpCampaigns.init === 'function') {
                ProductPlpCampaigns.init();
            }
            unblockUI();
        })
        .fail(partialSearchFailure);
    }



    // ********************** INIT *************************************


    searchBody.on("change", "#searchForm input[type=checkbox], #mobileSearchForm input[type=checkbox]", function() {

        if (clearInProgress) {
            return;
        }

        var checkbox = $(this);

        var filterLabel = checkbox.data("filter-label"),
            filterCat = checkbox.data("filter-cat");

        if(checkbox.is(':checked')){
            gaEvent("Filter", filterCat, filterLabel);
        }

    });

    searchBody.on("click", ".apply_filters a, .mobile-apply-filters a", function(e) {

        e.preventDefault();

        var isMobile = false;

        if($(this).parent().hasClass("mobile-apply-filters")){
            isMobile = true;
            window.viveCategoryPage.closeMobileFilterMenu();
        }

        executeSearch(isMobile);

        $("html, body").animate({ scrollTop: 0 }, 600);

    });


    searchBody.on('click','.clean_all_filters, .filter-clear', function removeFilters() {

        clearInProgress = true;
        var selectedFilters = $('.selected-filter-li');

        selectedFilters.each( function(){
            removeSelectedFilter($(this));
        });


        if($(this).hasClass("filter-clear")){
            window.viveCategoryPage.closeMobileFilterMenu();
            executeSearch(true);
        }
        else{
            executeSearch(false);
        }

        clearInProgress = false;
    });


    searchBody.on('click','.delete_filter', function removeFilter() {

        var selectedFilter = $(this).closest(".selected-filter-li");

        removeSelectedFilter(selectedFilter);

        executeSearch(false);

    });


    function removeSelectedFilter(selectedFilter){

        var filterName = selectedFilter.data('filter-name');
        var filterValue = selectedFilter.data('filter-value');
        var filterType = selectedFilter.data('filter-type');

        var filters = searchBody.find('input[name="' + filterName + '"]');

        if (filterType === 'text') {
            filters.val("");
        } else {
            filters.each(function () {
                var checkbox = $(this);
                if (checkbox.val() === filterValue) {
                    checkbox.prop('checked', false);
                }
            });
        }
    }

    searchBody.on("change",".product_sorting_select, .mobile-category-sort",function sort() {

        var sortingKey = $(this).val();

        var selectedText = $(this).find("option:selected").text();

        $('#searchForm').find('input[name="sort"]').val(sortingKey);
        $('#mobileSearchForm').find('input[name="sort"]').val(sortingKey);

        gaEvent('Filter', 'Sorting', selectedText);

        var isMobile = false;

        if($(this).hasClass("mobile-category-sort")){
            isMobile = true;
        }

        executeSearch(isMobile);
    });


    window.viveCategoryPage.loadOtherMobilePages = function(pageId){

        var originalPath = window.location.pathname;
        var queryPath = window.location.href.split("?").slice(1).join("?");

        return $.ajax('/ajax/mobile-search/loadOtherPages.php', {
                    method: 'GET',
                    data: 'originalPath='+originalPath+'&'+queryPath+'&page='+pageId
                }).done(function (responseData, textStatus, jqXHR) {

                    $(".product-list").append(responseData.html);

                    window.viveCategoryPage.lazyLoadImages();
                    window.viveCategoryPage.initOtherColors();
                    Vivense.favoriteActions.init();

                    if(window.ProductPlpCampaigns && typeof window.ProductPlpCampaigns.init === 'function') {
                        ProductPlpCampaigns.init();
                    }

                });

    };


    searchBody.on('change','.switch-input', function () {
        if($(this).is(':checked')){
            $('input[name="sort_' + $(this).data("name") + '"]:checkbox:not(:checked)').prop('checked',true);
            $('input[name="sort_' + $(this).data("name") + '"]:not(.filter_input)').val(1);

            var filterNameLabel = $(this).parent("label").find("span.filter_name");
            console.log(filterNameLabel);
            gaEvent("Filter","Checked",filterNameLabel.length > 0 ? filterNameLabel.text() : "Vivense Collection");

            executeSearch(false);
        }
        else{
            $('input[name="sort_' + $(this).data("name") + '"]:checkbox(:checked)').prop('checked',false);
            $('input[name="sort_' + $(this).data("name") + '"]:not(.filter_input)').val("");
            executeSearch(false);
        }
    });


    searchBody.on("click",".category-banner-wrapper__inner--bg-img", function () {
        $('html, body').animate({scrollTop: $(".product-list-wrapper").position().top - 10}, "slow");

    });

    window.onpopstate = popstate;

    history.replaceState({ initialState : true }, document.title);
};

Vivense.init['category'].push(categorySearchJS);
Vivense.init['search'].push(categorySearchJS);
Vivense.init['upholstery-fabric'].push(categorySearchJS);